import { Smartphone, Download, ShieldCheck, MapPin, FileText } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";
import { API } from "@/lib/api";

const APK_URL = `${API}/app/android`;

const POINTS = [
  [Smartphone, "Book cars in a few taps"],
  [ShieldCheck, "Verify your licence with your camera"],
  [MapPin, "Share live trip location"],
  [FileText, "Download GST invoices"],
];

export function GetApp() {
  return (
    <section id="get-app" className="scroll-mt-24 bg-white px-3 pb-5 sm:px-5" data-testid="home-get-app">
      <div className="mx-auto grid max-w-[1600px] gap-8 overflow-hidden rounded-2xl bg-[#FFF1E8] px-6 py-10 sm:px-10 md:grid-cols-[1.2fr_1fr] md:items-center lg:px-16">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-hc-goldh">HooreCars for Android</p>
          <h2 className="mt-3 font-display text-2xl font-extrabold leading-tight text-hc-ink sm:text-[28px] lg:text-[32px]">Get the HooreCars app</h2>
          <p className="mt-3 max-w-md text-[15px] leading-6 text-neutral-600">Everything on the website, built for your phone.</p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2">
            {POINTS.map(([Icon, t]) => <li key={t} className="flex items-center gap-2.5 text-sm font-medium text-neutral-800"><Icon className="h-4 w-4 text-[#FF5A00]" />{t}</li>)}
          </ul>
          <div className="mt-7 flex flex-wrap items-center gap-6">
            <a href={APK_URL} download data-testid="home-download-apk"
              className="inline-flex items-center gap-2 rounded-xl bg-[#FF5A00] px-7 py-3.5 font-semibold text-white shadow-lg shadow-orange-500/30 transition-transform duration-200 hover:-translate-y-0.5">
              <Download className="h-5 w-5" />Download for Android
            </a>
            <div className="hidden items-center gap-3 md:flex" data-testid="home-apk-qr">
              <div className="rounded-xl bg-white p-2 shadow-sm"><QRCodeSVG value={APK_URL} size={92} fgColor="#0B3D26" level="M" /></div>
              <p className="max-w-[130px] text-xs leading-5 text-neutral-600">On a computer? Scan with your phone camera to download.</p>
            </div>
          </div>
          <p className="mt-3 text-xs text-neutral-500" data-testid="home-apk-meta">Version 1.6.1 · 115 MB · Android 7 or later. Upgrading from 1.5.x or older? Uninstall the old HooreCars app first (new signing key), then install and sign in again.</p>
        </div>
        <div className="relative mx-auto hidden h-[320px] w-[170px] rounded-[32px] border-[6px] border-hc-ink bg-hc-cream shadow-2xl md:block">
          <div className="mx-auto mt-2 h-1.5 w-12 rounded-full bg-neutral-900" />
          <div className="p-4">
            <p className="text-sm font-extrabold italic">Hoore<span className="text-hc-goldh">Cars</span></p>
            <p className="mt-4 text-lg font-extrabold leading-tight">Rent a car anytime, anywhere.</p>
            <div className="mt-4 space-y-1.5 rounded-xl bg-white p-2.5 text-[9px] shadow-sm"><p className="text-neutral-500">Pickup</p><p className="font-bold">Tomorrow, 10:00 am</p></div>
            <div className="mt-3 rounded-full bg-[#FF5A00] py-2 text-center text-[10px] font-bold text-white">Book a car</div>
            <div className="mt-3 rounded-lg bg-hc-gold/30 p-2 text-[9px] font-bold text-hc-deep">Save up to 30% on 3+ day trips</div>
          </div>
        </div>
      </div>
    </section>
  );
}
